import { render, staticRenderFns } from "./tab12.vue?vue&type=template&id=146a85b6&scoped=true&"
import script from "./tab12.vue?vue&type=script&lang=js&"
export * from "./tab12.vue?vue&type=script&lang=js&"
import style0 from "./tab12.vue?vue&type=style&index=0&id=146a85b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146a85b6",
  null
  
)

export default component.exports